import { Dispatch } from 'react'
import { AnyAction } from '@reduxjs/toolkit'
import {
  getRestaurantsByFilters,
  loadCatalogTags,
  updateOutput,
} from '@features/Restaurant/RestaurantFilters/model/thunks'
import { globalStore } from '@app/model/store'
import {
  applyPrecheckedListFilters,
  setReady,
  initCheckedFiltersItems,
  setVisible,
  setIsPreloaderResults,
  resetFilters,
  updateParamsRequest,
} from '@features/Restaurant/RestaurantFilters/model/slice'
import { fetchRests } from '@widgets/Restaurant/Map/model/thunks'
import { cleanRestaurantsData } from '@widgets/Restaurant/Map/model/slice'

const isCatalogFiltersLoaded = () => {
  const stateFilters = globalStore.getState().features.restaurant_filters.filters

  // @ts-ignore
  return Object.values(stateFilters).some((el) => !!el.list?.length)
}

export type TypeArgsInitRestFilters = {
  tags?: string[]
  preloading: boolean
}
export const initRestaurantFilters = (data: TypeArgsInitRestFilters) => async (dispatch: Dispatch<AnyAction>) => {
  if (!isCatalogFiltersLoaded()) {
    // @ts-ignore
    await dispatch(loadCatalogTags())
  }
  dispatch(setIsPreloaderResults(data.preloading))
  dispatch(initCheckedFiltersItems(data.tags || []))
  dispatch(setVisible(true))
  // @ts-ignore
  dispatch(getRestaurantsByFilters()).finally(() => {
    // @ts-ignore
    dispatch(updateOutput()).finally(() => {
      dispatch(setReady(true))
    })
  })
}

export const resetAllFilters = () => async (dispatch: Dispatch<AnyAction>) => {
  dispatch(resetFilters('all'))
  // @ts-ignore
  dispatch(updateOutput())
}

export const applyFilters = () => async (dispatch: Dispatch<AnyAction>) => {
  dispatch(applyPrecheckedListFilters())
  // @ts-ignore
  await dispatch(updateOutput())
}

export const applyFilterAndUpdate = () => async (dispatch: Dispatch<AnyAction>) => {
  const currentCityId =
    globalStore.getState().features.map.nearestCityId || globalStore.getState().global.currentCity.id

  dispatch(applyPrecheckedListFilters())
  // @ts-ignore
  dispatch(updateParamsRequest({ cityId: String(currentCityId) }))
  // @ts-ignore
  await dispatch(updateOutput())
  dispatch(cleanRestaurantsData())
  // @ts-ignore
  await dispatch(fetchRests({ clearRequest: true }))
}
